import { Component, h } from '@stencil/core';

@Component({
  tag: 'signet-checkmark-form',
  styleUrl: 'signet-checkmark-form.scss',
  // shadow: true,
})
export class SignetCheckmarkForm {
  render() {
    return (
      <ol class="signet-checkmark-form">
        <slot></slot>
      </ol>
    );
  }
}
